import React from "react";
import { Box } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

/**
 * Aggregate Bar Chart Component using MUI X Charts
 * Displays aggregate data (campaigns launched or partnerships) over time
 * @param {Object} props
 * @param {Object} props.data - Chart data with columnData and columnCategories
 * @param {string} props.section - Section identifier for tooltip label
 * @returns {import("react").ReactElement}
 */
export default function AggregateBar(props) {
  const { data, section } = props;

  if (!data || !data.columnData || !data.columnCategories) {
    return (
      <Box sx={{ position: "relative" }}>
        <Box sx={{ display: "inline-block", width: 590, height: 300, mb: 2.5 }} />
      </Box>
    );
  }

  const { columnData, columnCategories } = data;

  const metric =
    section === "dashboardCampaignsLaunched" ? "campaigns launched" : "new partnerships";

  return (
    <Box sx={{ position: "relative" }}>
      <Box sx={{ display: "inline-block", width: 590, height: 300, mb: 2.5 }}>
        <BarChart
          xAxis={[
            {
              scaleType: "band",
              data: columnCategories,
              tickLabelStyle: {
                fontSize: 10,
              },
            },
          ]}
          yAxis={[
            {
              disableLine: true,
            },
          ]}
          series={[
            {
              data: columnData,
              color: "#03a9f4",
              valueFormatter: (value) => `${value?.toLocaleString() || 0} ${metric}`,
            },
          ]}
          width={590}
          height={300}
          margin={{ top: 20, right: 20, bottom: 30, left: 50 }}
          hideLegend
        />
      </Box>
    </Box>
  );
}
